import React, {useEffect, useState} from 'react';
import './MenuDemoPolicyToast.css';
import PolicyPurchaseToast from '../../PolicyPurchaseToast/PolicyPurchaseToast';

// Сколько тост висит на экране, не считая времени выезда и ухода
const VISIBLE_DURATION_MS = 3000;
// Совпадает с transition в MenuDemoPolicyToast.css
const SLIDE_DURATION_MS = 350;

/**
 * Тост «игрок купил политику» на витрине главного меню: покупка — самое
 * заметное решение партии, а на поле она никак не видна.
 *
 * Сама плашка — общий PolicyPurchaseToast (такой же показывается в матче),
 * здесь только жизненный цикл показа и классы размещения: выезжает справа и
 * висит у плашки раунда (при развернутой плашке не показывается вовсе — см.
 * MenuDemoGame).
 */
function MenuDemoPolicyToast({player, policy, isCompact, onHidden}) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Появление через кадр: элемент должен смонтироваться сдвинутым, иначе
    // CSS-переход не сработает и тост просто возникнет на месте
    const showTimer = setTimeout(() => setIsVisible(true), 30);
    const hideTimer = setTimeout(() => setIsVisible(false), 30 + VISIBLE_DURATION_MS);
    const unmountTimer = setTimeout(
      () => onHidden?.(),
      30 + VISIBLE_DURATION_MS + SLIDE_DURATION_MS
    );

    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
      clearTimeout(unmountTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PolicyPurchaseToast
      player={player}
      policy={policy}
      isCompact={isCompact}
      className={`menu-demo-policy-toast${isCompact ? ' menu-demo-policy-toast_compact' : ''}${isVisible ? ' menu-demo-policy-toast_visible' : ''}`}
    />
  );
}

export default MenuDemoPolicyToast;
